module.exports = __webpack_public_path__ + "static/img/shanghujiaz.6b53306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shanghujiaz.jpg
// module id = y9YO
// module chunks = 19